// #936 — menu lateral do painel (`AppShell`) e o índice de Resultados
// (`/events/results`), a página que o item "Resultados" abre.
import { defineMessages } from '../core';

export const navT = defineMessages('nav', {
  pt: {
    /// `aria-label` do `<nav>`. É por ele que o E2E acha o menu.
    menuLabel: 'Menu principal',
    openMenu: 'Abrir menu',
    closeMenu: 'Fechar menu',
    sections: { organization: 'Organização', management: 'Gestão' },
    items: {
      events: 'Eventos',
      results: 'Resultados',
      users: 'Usuários',
      trackers: 'Rastreadores',
      business: 'Negócio',
      growth: 'Crescimento',
      flyover: 'Vídeo 3D',
    },
    signOut: 'Sair',
    resultsIndex: {
      title: 'Resultados',
      intro: 'Escolha o evento para abrir a lista completa de resultados.',
      loadFailed: (message: string) => `Falha carregando eventos: ${message}`,
      emptyTitle: 'Nenhum evento publicado ainda',
      emptyBody: 'Resultados aparecem aqui depois que o evento é publicado.',
      running: 'Em andamento',
      published: 'Publicado',
      finished: 'Encerrado',
      open: 'Ver resultados',
    },
  },
  en: {
    menuLabel: 'Main menu',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    sections: { organization: 'Organization', management: 'Management' },
    items: {
      events: 'Events',
      results: 'Results',
      users: 'Users',
      trackers: 'Trackers',
      business: 'Business',
      growth: 'Growth',
      flyover: '3D video',
    },
    signOut: 'Sign out',
    resultsIndex: {
      title: 'Results',
      intro: 'Pick an event to open its full results list.',
      loadFailed: (message) => `Failed to load events: ${message}`,
      emptyTitle: 'No published events yet',
      emptyBody: 'Results show up here once the event is published.',
      running: 'In progress',
      published: 'Published',
      finished: 'Finished',
      open: 'View results',
    },
  },
  es: {
    menuLabel: 'Menú principal',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    sections: { organization: 'Organización', management: 'Gestión' },
    items: {
      events: 'Eventos',
      results: 'Resultados',
      users: 'Usuarios',
      trackers: 'Rastreadores',
      business: 'Negocio',
      growth: 'Crecimiento',
      flyover: 'Video 3D',
    },
    signOut: 'Salir',
    resultsIndex: {
      title: 'Resultados',
      intro: 'Elige el evento para abrir la lista completa de resultados.',
      loadFailed: (message) => `Error al cargar los eventos: ${message}`,
      emptyTitle: 'Todavía no hay eventos publicados',
      emptyBody: 'Los resultados aparecen aquí cuando el evento se publica.',
      running: 'En curso',
      published: 'Publicado',
      finished: 'Finalizado',
      open: 'Ver resultados',
    },
  },
});
